export default __webpack_public_path__ + "static/media/smart-manufacturing-webcast.d1dec0aa.svg";